export default __webpack_public_path__ + "static/2020-9c93e03c6967c74bd316f176c8d54254.jpeg";